
import './App.css';
import Intro from './components/Intro';
import About from './components/About';
import Navbar from './components/Navbar';
import Menu from './components/Menu';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
// import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  
  return (
    <>
    <Router>
      <Navbar title="Mamma's Home" contact="Contact" about="About" menu='Menu' />
      
      <Routes>
        <Route exact path="/mammas_cafe" element={<Intro />}>
      </Route>
        <Route exact path="/mammas_cafe/menu" element={<Menu />}>
      </Route>
        <Route exact path="/mammas_cafe/about" element={<About />}>
        
      </Route>
        {/* <Route exact path="/contact" element={<Contact />}>
        
      </Route> */}
      </Routes>
      <Footer/>
    </Router>
    </>
  );
}

export default App;
